import {useEffect, useState} from 'react';

import {useLoginContext} from '@/contexts/LoginProcessContext';
import {useResendCountdown} from '@/hooks/login/useResendCountdown';

import MainButton, {MainButtonProps} from '@/components/ui/buttons/MainButton/MainButton';

interface Props extends MainButtonProps {
  label: string;
  showCountdown?: boolean;
  resendCooldownEnd?: string;
  setResendCooldownEnd?: (end?: string) => void;
}

export const ResendButton = ({
  label,
  showCountdown,
  resendCooldownEnd: resendCooldownEndFromProps,
  setResendCooldownEnd: setResendCooldownEndFromProps,
  ...props
}: Props) => {
  const {
    resendCooldownEnd: resendCooldownEndFromContext,
    setResendCooldownEnd: setResendCooldownEndFromContext,
  } = useLoginContext();

  const [resendFormattedTime, setResendFormattedTime] = useState('');
  const {createCountdownCallback, startCountdown} = useResendCountdown();

  useEffect(() => {
    const setResendCooldownEnd = setResendCooldownEndFromProps || setResendCooldownEndFromContext;
    const countdownCallback = createCountdownCallback({
      setResendFormattedTime,
      onEndCountdown: () => setResendCooldownEnd(undefined),
    });

    const resendCooldownEnd = resendCooldownEndFromProps || resendCooldownEndFromContext;
    if (resendCooldownEnd) {
      startCountdown({
        resendCooldownEnd,
        countdownCallback,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resendCooldownEndFromContext, resendCooldownEndFromProps]);

  const canResend = !resendFormattedTime;
  const shouldShowCountdown = Boolean(resendFormattedTime && showCountdown);
  const finalLabel = shouldShowCountdown ? `Resend in ${resendFormattedTime}` : label;

  return (
    <MainButton disabled={!canResend} label={finalLabel} id="send-sms-button" variant="TERTIARY" {...props} />
  );
};
